import app from "../_app";

const searchTriggers = [...document.querySelectorAll('.js-search-toggle')];

searchTriggers.map(trigger => {
    // const search = document.querySelector('.js-search');
    // const overlay = document.createElement('div');
    // overlay.classList.add('header__search-overlay');
    //
    // trigger.addEventListener('click', () => {
    //     if(!search.hasAttribute('data-active')) {
    //         app.lockBody();
    //         search.setAttribute('data-active', '');
    //
    //         search.parentNode.insertBefore(overlay, search.nextSibling);
    //
    //         overlay.style.display = 'block';
    //     } else {
    //         app.unlockBody()
    //         overlay.style.display = 'none';
    //         search.removeAttribute('data-active');
    //     }
    //
    // })
    //
    // overlay.addEventListener('click', () => {
    //     app.unlockBody()
    //     overlay.style.display = 'none';
    //     search.removeAttribute('data-active');
    // });
})
